/**
 * SectionHeader — the display-serif section title with a short accent rule.
 * The rule is the consultancy-register signature that opens every section.
 */
export function SectionHeader({ title }: { title: string }) {
  return (
    <header className="mb-3">
      <h2 className="font-[family-name:var(--report-font-display)] text-[1.35rem] font-semibold leading-tight tracking-tight text-foreground">
        {title}
      </h2>
      <div
        className="mt-2 h-px w-10 rounded-full bg-[var(--report-accent)]"
        aria-hidden="true"
      />
    </header>
  )
}
